/** The active-huddle bar at the bottom of the sidebar (translatable HuddleBar, wired to the call view model). */
import { Shell, type OpenTarget } from "@bundle/core";
import { HuddleBar, useHuddle, useT, useWorkspace } from "@bundle/ui";

export function SidebarHuddle({ open, canSplit }: { open: (url: string, target?: OpenTarget) => void; canSplit: boolean }) {
  const huddle = useHuddle();
  const ws = useWorkspace();
  const t = useT();
  if (huddle === null) return null;
  const { vm, state } = huddle;
  const channelId = state.call.channelId;
  if (state.call.status === "idle" || channelId === undefined) return null;
  return (
    <div className="sidebar-huddle">
      <HuddleBar
        title={state.title}
        isDm={state.isDm}
        status={state.call.status}
        tiles={state.tiles}
        me={state.me}
        canShareScreen={state.supports.screenShare}
        notice={state.declined === undefined ? undefined : t("huddle.declined", { name: state.declined.name })}
        onOpen={() => open(Shell.formatUrl({ type: "huddle", ws: ws.slug, huddleId: channelId }), canSplit ? "split" : "current")}
        onMute={() => vm.toggleMute()}
        onVideo={() => vm.toggleVideo()}
        onScreen={() => vm.toggleScreen()}
        onHand={() => vm.toggleHand()}
        onSettings={() => vm.openSettings()}
        onLeave={() => void vm.leave()}
        testID="huddle-bar"
      />
    </div>
  );
}
